import {loader} from './loader'
import {displayPersonalInfoNotFilledModal} from './apply'
import {init_phone} from "./phone";

export default function authModal() {
    (function( $ ) {
        'use strict';

        const isInfoFilled = true; // window.glob_obj.is_personal_info_filled

        if (window.authmodal.cart_mode){
            displayAuthModal('signin', true);
        }

        if (! isInfoFilled && window.authmodal.cart_page && ! window.authmodal.cart_mode){
            displayPersonalInfoNotFilledModal();
        }

        $(document).on('click', '.check-sign-in', function (e) {
            if (!window.glob_obj.is_logged_in){
                e.preventDefault();
                displayAuthModal('signin');
            }
        })

        $(document).on('click', '#sign-in-header', function (e) {
            e.preventDefault();
            displayAuthModal('signin');
        })

        $(document).on('click', '#sign-up-header', function (e) {
            e.preventDefault();
            displayAuthModal('signup');
        })

        $(document).on('click', '.sign-up-affiliate', function (e) {
            e.preventDefault();
            displayAuthModal('signup');
        })

        $(document).on('click', '.auth-modal-open', function(e){
            e.preventDefault();

            $.ajax({
                url: window.authmodal.ajaxurl,
                method: 'POST',
                dataType: 'json',
                data: {
                    action: 'auth_modal',
                    _ajax_nonce: window.authmodal.nonce_modal
                },
                beforeSend: function(){
                },
                success: function (response) {
                    $('body').append(response.html);

                    $('.modal').modal().on('hidden.bs.modal', function (e) {
                        $(this).remove();
                    });

                },
                error: function(error){
                    console.log(error);
                }
            });
        });

        $(document).on('click', '.sign-up-show', function (e) {
            e.preventDefault();
            $('.sign-in-wrapper').hide();
            $('.sign-up-wrapper').show();
            $(this).closest('.modal-content').find('.modal-title').html('Sign Up');
        });

        $(document).on('click', '.sign-in-show', function (e) {
            e.preventDefault();
            $('.sign-up-wrapper').hide();
            $('.sign-in-wrapper').show();
            $(this).closest('.modal-content').find('.modal-title').html('Sign In');
        });

        $(document).on('click', '#sign-up', function (e){
            e.preventDefault();
            let $this = $(this);

            var formData = new FormData(document.getElementById('sign-up-form'));

            formData.append('action', 'aw_register');
            formData.append('_ajax_nonce', window.authmodal.nonce_register);

            $.ajax({
                url: window.authmodal.ajaxurl,
                method: 'POST',
                contentType: false,
                processData: false,
                data: formData,
                beforeSend: function(){
                    $('.sign-up-messages').html('');
                    $this.attr('disabled', 'disabled');
                },
                success: function (response) {
                    $this.removeAttr('disabled');
                    if (response.success) {
                        window.location = response.redirect;
                    } else {
                        if(response.messages){
                            $('.sign-up-messages').html(response.messages.join(', '));
                        }
                    }
                },
                error: function(error){
                    console.log(error);
                }
            });
        });

        $(document).on('click', '#sign-in', function (e){
            e.preventDefault();
            let $this = $(this);

            var formData = new FormData(document.getElementById('sign-in-form'));

            formData.append('action', 'aw_login');
            formData.append('_ajax_nonce', window.authmodal.nonce_login);

            $.ajax({
                url: window.authmodal.ajaxurl,
                method: 'POST',
                contentType: false,
                processData: false,
                data: formData,
                beforeSend: function(){
                    $('.sign-in-messages').html('');
                    $this.attr('disabled', 'disabled');
                },
                success: function (response) {
                    $this.removeAttr('disabled');
                    if (response.success) {
                        window.location = response.redirect;
                    } else {
                        if(response.messages){
                            $('.sign-in-messages').html(response.messages.join(', '));
                        }
                    }
                },
                error: function(error){
                    console.log(error);
                }
            });
        });

    })(jQuery);
}

export function displayAuthModal (form = 'signin', staticBg = false) {
    $.ajax({
        url: window.authmodal.ajaxurl,
        method: 'POST',
        dataType: 'json',
        data: {
            action: 'auth_modal',
            form: form,
            _ajax_nonce: window.authmodal.nonce_modal
        },
        beforeSend: function(){
            loader.show()
        },
        success: function (response) {
            loader.hide()
            $('body').append(response.html);
            let opt = {};
            if (staticBg){
                opt = {backdrop: 'static', keyboard: false}
            }
            $('#auth-modal').modal(opt).on('hidden.bs.modal', function(e){
                $('#auth-modal').remove()
            }).on('shown.bs.modal', function (e){
                init_phone('reg_phone');
            });
        },
        error: function(error){
            loader.hide()
            console.log(error);
        }
    });
}